import React from 'react';
import { useAppSettingsStore } from '../../stores/appSettingsStore';

const LanguageToggle: React.FC<{ className?: string; label?: string }> = ({ className, label = 'Toggle language' }) => {
  const { language, setLanguage } = useAppSettingsStore();

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'nl' : 'en';
    setLanguage(newLang);
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className={className ?? `p-2 rounded-xl bg-background dark:bg-background-dark
                border border-borderGrey dark:border-borderGrey-dark
                text-text dark:text-text-dark
                transition-all duration-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-backgroundGreen/20 dark:focus:ring-backgroundGreen-dark/20 focus:border-backgroundGreen`}
      aria-label={label}
      title={label}
    >
      <span className="w-5 h-5 flex items-center justify-center font-semibold">
        {language === 'en' ? 'NL' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageToggle;